import type { Message } from "modules/chat/model/chat";

export const OPTIMISTIC_MESSAGE_PREFIX = "chat-optimistic:";

export function isOptimisticMessage(message: Message): boolean {
  return message.id.startsWith(OPTIMISTIC_MESSAGE_PREFIX);
}

function isAcknowledgementFor(
  optimistic: Message,
  persisted: Message
): boolean {
  return (
    isOptimisticMessage(optimistic) &&
    optimistic.chatId === persisted.chatId &&
    optimistic.senderId === persisted.senderId &&
    optimistic.receiverId === persisted.receiverId &&
    (optimistic.type ?? "") === (persisted.type ?? "") &&
    (optimistic.tradeId ?? "") === (persisted.tradeId ?? "")
  );
}

/**
 * Installs a persisted REST/WebSocket message without duplicating either an
 * earlier delivery of that message or the sender's optimistic cache entry.
 */
export function reconcileChatMessage(
  messages: Message[],
  persisted: Message
): Message[] {
  const persistedIndex = messages.findIndex(
    (message) => message.id === persisted.id
  );
  const optimisticIndex = messages.findIndex((message) =>
    isAcknowledgementFor(message, persisted)
  );

  if (persistedIndex !== -1) {
    if (optimisticIndex === -1 || optimisticIndex === persistedIndex) {
      return messages;
    }
    return messages.filter((_, index) => index !== optimisticIndex);
  }

  if (optimisticIndex !== -1) {
    const reconciled = [...messages];
    reconciled[optimisticIndex] = persisted;
    return reconciled;
  }

  return [...messages, persisted];
}

export function removeChatMessage(messages: Message[], id: string): Message[] {
  return messages.filter((message) => message.id !== id);
}
